"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidEstimateRequestToJSON = exports.BidEstimateRequestFromJSONTyped = exports.BidEstimateRequestFromJSON = exports.instanceOfBidEstimateRequest = void 0;
var runtime_1 = require("../runtime");
var AssetFormat_1 = require("./AssetFormat");
var BidStrategyRequest_1 = require("./BidStrategyRequest");
var CampaignAdProduct_1 = require("./CampaignAdProduct");
var CampaignChannel_1 = require("./CampaignChannel");
var FrequencyCap_1 = require("./FrequencyCap");
var OptimizationPrefs_1 = require("./OptimizationPrefs");
var Targets_1 = require("./Targets");
var VideoDeliveryFormat_1 = require("./VideoDeliveryFormat");
/**
 * Check if a given object implements the BidEstimateRequest interface.
 */
function instanceOfBidEstimateRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "assetFormat" in value;
    isInstance = isInstance && "objective" in value;
    isInstance = isInstance && "bidStrategy" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "targets" in value;
    return isInstance;
}
exports.instanceOfBidEstimateRequest = instanceOfBidEstimateRequest;
function BidEstimateRequestFromJSON(json) {
    return BidEstimateRequestFromJSONTyped(json, false);
}
exports.BidEstimateRequestFromJSON = BidEstimateRequestFromJSON;
function BidEstimateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'assetFormat': (0, AssetFormat_1.AssetFormatFromJSON)(json['asset_format']),
        'objective': (0, OptimizationPrefs_1.OptimizationPrefsFromJSON)(json['objective']),
        'bidStrategy': (0, BidStrategyRequest_1.BidStrategyRequestFromJSON)(json['bid_strategy']),
        'currency': json['currency'],
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'targets': (0, Targets_1.TargetsFromJSON)(json['targets']),
        'hierarchyDraftId': !(0, runtime_1.exists)(json, 'hierarchy_draft_id') ? undefined : json['hierarchy_draft_id'],
        'adsetDraftId': !(0, runtime_1.exists)(json, 'adset_draft_id') ? undefined : json['adset_draft_id'],
        'videoDeliveryFormats': !(0, runtime_1.exists)(json, 'video_delivery_formats') ? undefined : (new Set(json['video_delivery_formats'].map(VideoDeliveryFormat_1.VideoDeliveryFormatFromJSON))),
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'channel': !(0, runtime_1.exists)(json, 'channel') ? undefined : (0, CampaignChannel_1.CampaignChannelFromJSON)(json['channel']),
        'adProduct': !(0, runtime_1.exists)(json, 'ad_product') ? undefined : (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
    };
}
exports.BidEstimateRequestFromJSONTyped = BidEstimateRequestFromJSONTyped;
function BidEstimateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_account_id': value.adAccountId,
        'asset_format': (0, AssetFormat_1.AssetFormatToJSON)(value.assetFormat),
        'objective': (0, OptimizationPrefs_1.OptimizationPrefsToJSON)(value.objective),
        'bid_strategy': (0, BidStrategyRequest_1.BidStrategyRequestToJSON)(value.bidStrategy),
        'currency': value.currency,
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'hierarchy_draft_id': value.hierarchyDraftId,
        'adset_draft_id': value.adsetDraftId,
        'video_delivery_formats': value.videoDeliveryFormats === undefined ? undefined : (Array.from(value.videoDeliveryFormats).map(VideoDeliveryFormat_1.VideoDeliveryFormatToJSON)),
        'category': value.category,
        'channel': (0, CampaignChannel_1.CampaignChannelToJSON)(value.channel),
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
    };
}
exports.BidEstimateRequestToJSON = BidEstimateRequestToJSON;
